export const PRODUCTION_HOSTS = {
    catalog: 'https://vod.wix.com',
    catalogEditorX: 'https://vod.editorx.com',
    editorWixApps: 'https://editor.wixapps.net',
    files: 'https://vod-meta.wix.com',
    filesEditorX: 'https://vod-meta.editorx.com',
    image: 'https://images-vod.wixmp.com',
    wixFiles: 'https://files.wix.com/files',
    paypal: 'https://dgs.wixapps.net',
    pixWix: 'https://pix.wix.com/services',
    manage: 'https://manage.wix.com',
    vodServer: 'https://vod-server.wix.com',
};
//# sourceMappingURL=hosts.js.map